module.exports = __webpack_public_path__ + "img/menu.3861d733.svg";